export default "__VITE_ASSET__BQWLiPF6__"